export const INVENTORY_STATE_ASSIGNED = 'assigned'
export const INVENTORY_STATE_PREASSIGNED = 'preassigned'
export const INVENTORY_STATE_SOLD = 'sold'
export const INVENTORY_STATE_PRESOLD = 'presold'
export const INVENTORY_STATE_EXPIRED = 'expired'
export const INVENTORY_STATE_RETURNED_BY_PARTNER = 'returned_by_partner'
export const INVENTORY_STATE_RETURNED_BY_ARVAL = 'returned_by_arval'
export const INVENTORY_STATE_RETURNED = 'returned'
export const INVENTORY_STATE_PROLONGED = 'prolonged'
export const INVENTORY_STATE_PARKED = 'parked'
export const INVENTORY_STATE_ACQUIRED_B2B = 'acquired_b2b'
export const INVENTORY_STATE_RESOLD_B2B = 'resold_b2b'
